import { api } from 'common';

export function getDefaultEvaluationConfig(): api.FlowDefinition.EvaluationBlockConfig {
  return {
    output: '',
    reference: '',
    evaluationType: api.FlowDefinition.EvaluationType.Accuracy,
  };
}
